// extracted by mini-css-extract-plugin
module.exports = {"main":"ProjectsPage_main__PZ9po","table":"ProjectsPage_table__L-IUq","rowHeading":"ProjectsPage_rowHeading__2PteJ","rowData":"ProjectsPage_rowData__37NQs"};